const OFFICIAL_LIVE_CHANNELS = [
  {
    domains: ['aljazeera.com', 'aljazeera.net'],
    names: ['al jazeera', 'aljazeera'],
    url: 'https://www.youtube.com/aljazeeraenglish/live'
  },
  {
    domains: ['france24.com'],
    names: ['france 24', 'france24'],
    url: 'https://www.youtube.com/@France24_en/live'
  },
  {
    domains: ['reuters.com'],
    names: ['reuters'],
    url: 'https://www.youtube.com/channel/UChqUTb7kYRX8-EiaN3XFrSQ/live'
  }
];

function normalize(value = '') {
  return String(value).normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().trim();
}

function hostname(value = '') {
  const raw = String(value).toLocaleLowerCase().replace(/^https?:\/\//, '').split(/[/?#:]/, 1)[0];
  return raw.replace(/^www\./, '');
}

function matchesDomain(host, domain) {
  return host === domain || host.endsWith(`.${domain}`);
}

export function getYouTubeLiveLink(article = {}) {
  const host = hostname(article.publisherDomain || '');
  const source = normalize(article.sourceName || '');

  for (const channel of OFFICIAL_LIVE_CHANNELS) {
    const domainMatch = channel.domains.some((domain) => matchesDomain(host, domain));
    const nameMatch = channel.names.some((name) => source.includes(normalize(name)));
    if (domainMatch || nameMatch) return { url: channel.url, official: true };
  }

  const publisher = String(article.sourceName || article.publisherDomain || 'world news').trim();
  const query = new URLSearchParams({ search_query: `${publisher} live news` });
  return { url: `https://www.youtube.com/results?${query.toString()}`, official: false };
}
